export default "assets/images/icons/cam-0536725c.svg";